import React from 'react';

import LivePersonaCardGroup from '../../cards/LivePersonaCard/LivePersonaCardGroup';

import type { RenderGroupReferenceType } from './types';

export const renderGroupHoverCard: RenderGroupReferenceType = (children, options) =>
  (options && <LivePersonaCardGroup {...options}>{children}</LivePersonaCardGroup>) || children;
